import font from "./fonts.json";
export default {
  loadPdf(pdfContent) {
    var pdfMake = require("pdfmake/build/pdfmake.js");
    pdfMake.vfs = {
      "siemreap.ttf": font.siemreap,
      "moul.ttf": font.moul,
      "battambang.ttf": font.battambang,
      "battambang_bold.ttf": font.battambang_bold,
    };
    pdfMake.fonts = {
      siemreap: {
        normal: "siemreap.ttf",
        bold: "siemreap.ttf",
      },
      moul: {
        normal: "moul.ttf",
        bold: "moul.ttf",
      },
      battambang: {
        normal: "battambang.ttf",
        bold: "battambang_bold.ttf",
      }
    };
    let docDefinition = {
      defaultStyle: {
        font: "battambang",
        fontSize: 4.6,
      },
      pageSize: "A4",
      pageMargins: [10, 20, 20, 30],
      content: pdfContent,
    };
    pdfMake.createPdf(docDefinition).open();
    docDefinition = {};
  }
};